import { render } from "./FooterCH.vue?vue&type=template&id=9f77f09c&scoped=true"
import script from "./FooterCH.vue?vue&type=script&lang=js"
export * from "./FooterCH.vue?vue&type=script&lang=js"

import "./FooterCH.vue?vue&type=style&index=0&id=9f77f09c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f77f09c"]])

export default __exports__